import { css } from 'styled-components';

/**
 * Row text in `theme.text.tableAssetItem`, as the old legacy table base painted it (the default
 * base leaves cells in `theme.text.tableHeader`). Used by the tables that were on that base, so
 * their text keeps its color until the redesign unifies it.
 */
const assetItemRowText = css`
  .rt-tbody .rt-tr-group :first-child > div {
    color: ${({ theme }) => theme.text.tableAssetItem};
  }
`;

export default assetItemRowText;
